type Filter = {
  areaKeyCodes: unknown[];
  customAreaKeys: unknown[];
  wayIds?: unknown[];
};

const isEmptyFilter = (filter: Filter): boolean => {
  return (
    filter.areaKeyCodes.length === 0 &&
    filter.customAreaKeys.length === 0 &&
    (filter.wayIds?.length ?? 0) === 0
  );
};

export { isEmptyFilter };
